import server from "@/api/server";

async function initRegistration(phone) {
  let res = await server.post("/agent/ext/reg/init", { phone });
  return res;
}

async function confirmRegistration(code, smsid) {
  let res = await server.post("/agent/ext/reg/confirm", { code, smsid });
  return res;
}

async function refreshRegistration(phone) {
  let res = await server.post("/agent/ext/reg/refresh", { phone });
  return res;
}

async function register({ phone, pass, smsid, clid, invitation_id }) {
  let res = await server.post("/account/register", { pass, phone, smsid, clid, invitation_id });
  return res;
}

export { initRegistration, confirmRegistration, refreshRegistration, register };
